const MockData = {
  productFamily: 'Consumable',
  categoryIdentifier: 'P1',
  globalArticleCode: 'G0000704',
  globalArticleName: 'TEREA Russet test 7',
  productLongDescription: 'TEREA Russet bestechen mit einem intensiven, gleichzeitig gerösteten Tabak.',
  productShortDescription: '<p>Intensiv und geröstet</p>',
  minimumOrderQuantity: 1,
  maximumOrderQuantity: 10,
  nominalContentPerUnitOfSales: 20,
  unitOfMeasure: 'PK',
  seo: {
      productsSeoUrl: 'terea-packung-russet',
      productsSeoTitle: 'TEREA Russet kaufen | Für IQOS ILUMA',
      productsSeoDescription: 'Jetzt bestellen: TEREA Russet Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
  },
  price: {
      value: 7,
      priceCurrency: 'EUR',
      priceChannel: 'web',
      priceType: 'Gross Price',
      isServiceFeeIncluded: false
  },
  baseArticle: {
      baseArticleCode: 'B0000160',
      baseModelName: 'TEREA PACK'
  },
  variants: [
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000692',
          globalArticleName: 'TEREA Amber',
          productLongDescription: 'TEREA Amber stehen für einen ausgewogenen sowie vollmundigen Tabak.',
          productShortDescription: 'Ausgewogen und vollmundig',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '3',
          body: '3',
          aroma: '4',
          cooling: '3',
          nicotineConcentration: '5.11',
          intensityMeter: '3',
          tankSize: '5.25ml',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#FFA500',
                  code: 'LIGHTORANGE',
                  name: 'LIGHTORANGE'
              },
              hexCode: '#D86018',
              code: 'AMB',
              description: 'AMBER SELECTION',
              name: 'Ausgewogen und vollmundig.'
          },
          price: {
              value: 8,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-amber',
              productsSeoTitle: 'TEREA Amber kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Amber Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:b627c828-b472-4dd4-ad1e-3a53ca3a1aa6/as/pmi_G0000692_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:f9de3245-9bcc-4c0f-a138-9ae89b864f0f/as/pmi_G0000692_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:c3a0191e-e1cb-4b20-896c-30e3446d4f7b/as/pmi_G0000692_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:3bb7211b-1669-4766-9227-6040da6caa86/as/pmi_G0000692_03_de.png'
              }
          ],
          badges: [
              {
                  fontColor: {
                      code: 'BGO',
                      hexCode: '#D2BF9A',
                      name: ''
                  },
                  backgroundColor: {
                      code: 'GRY',
                      hexCode: '#777777',
                      name: ''
                  }
              }
          ],
          pmiInternalProductCode: 'ME002822.12',
          gtin: '4023500045230',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000697',
          globalArticleName: 'TEREA Bronze',
          productLongDescription: 'TEREA Bronze versprechen einen kräftigen und abgerundeten Tabak.',
          productShortDescription: '<p>Kräftig und abgerundet</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '3',
          aroma: '5',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#AA7956',
                  code: 'BROWN',
                  name: 'Braun'
              },
              hexCode: '#7C3A2D',
              code: 'BRS',
              description: 'BRONZE SELECTION',
              name: 'Strong and well-rounded.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-bronze',
              productsSeoTitle: 'TEREA Bronze kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Bronze Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME002824.11',
          gtin: '4023500045254',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000704',
          globalArticleName: 'TEREA Russet test 7',
          productLongDescription: 'TEREA Russet bestechen mit einem intensiven, gleichzeitig gerösteten Tabak.',
          productShortDescription: '<p>Intensiv und geröstet</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '5',
          body: '3',
          aroma: '2',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#FF0000',
                  code: 'RED',
                  name: 'Rot'
              },
              hexCode: '#6F263D',
              code: 'RUS',
              description: 'Russet',
              name: 'Intense and roasted.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-russet',
              productsSeoTitle: 'TEREA Russet kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Russet Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME002826.11',
          gtin: '4023500045285',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000705',
          globalArticleName: 'TEREA Sienna',
          productLongDescription: 'TEREA Sienna kennzeichnen eine reichhaltige sowie holzige Tabaksorte.',
          productShortDescription: '<p>Reichhaltig und holzig</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '4',
          aroma: '3',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#FF0000',
                  code: 'RED',
                  name: 'Rot'
              },
              hexCode: '#B33D26',
              code: 'SIE',
              description: 'Sienna',
              name: 'Rich and woody.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-sienna',
              productsSeoTitle: 'TEREA Sienna kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Sienna Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 9994,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME006515.08',
          gtin: '4023500045278',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000710',
          globalArticleName: 'TEREA Teak',
          productLongDescription: 'TEREA Teak verkörpern eine gereifte und sinnlich warme Tabakmischung.',
          productShortDescription: '<p>Gereift und warm</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '3',
          aroma: '4',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#AA7956',
                  code: 'BROWN',
                  name: 'Braun'
              },
              hexCode: '#AE8A79',
              code: 'TEA',
              description: 'Teak',
              name: 'Matured and warm.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-teak',
              productsSeoTitle: 'TEREA Teak kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Teak Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME002821.11',
          gtin: '4023500045292',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000713',
          globalArticleName: 'TEREA Turquoise',
          productLongDescription: 'TEREA Turquoise zeichnen sich durch eine dezente und frische Tabakmischung aus.',
          productShortDescription: 'Dezent und frisch',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '2',
          body: '2',
          aroma: '1',
          cooling: '2',
          intensityMeter: '4',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#00B050',
                  code: 'GREEN',
                  name: 'Grün'
              },
              hexCode: '#008C95',
              code: 'TUR',
              description: 'TURQUOISE SELECTION',
              name: 'Dezent und frisch.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-turquoise',
              productsSeoTitle: 'TEREA Turquoise kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Turquoise Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10994,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80919.adobeaemcloud.com/adobe/assets/urn:aaid:aem:47143bb0-f9fa-43ee-baec-87f246ba086d/as/pmi_G0000713_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80919.adobeaemcloud.com/adobe/assets/urn:aaid:aem:53e43316-61b9-4668-8ec5-7e25b7db565d/as/pmi_G0000713_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80919.adobeaemcloud.com/adobe/assets/urn:aaid:aem:69a1d6e2-eaf2-4db8-a6f6-d4f0a4b1b4e6/as/pmi_G0000713_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80919.adobeaemcloud.com/adobe/assets/urn:aaid:aem:1bc68d6c-25a5-4562-85a7-62f2d5ebe869/as/pmi_G0000713_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME005189.10',
          gtin: '4023500045261',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000714',
          globalArticleName: 'TEREA Yellow Green',
          productLongDescription: 'TEREA Yellow Green eröffnen einen ausgeprägten​ und feinwürzigen Tabak.​&nbsp;',
          productShortDescription: 'Ausgeprägt und feinwürzig',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '2',
          aroma: '5',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#00B050',
                  code: 'GREEN',
                  name: 'Grün'
              },
              hexCode: '#999B30',
              code: 'YEG',
              description: 'YELLOW GREEN',
              name: 'Ausgeprägt und feinwürzig.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-yellow-greentereatest3',
              productsSeoTitle: 'TEREA Yellow Green kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Yellow Green Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:e5266320-71b3-447b-8ef7-80a6c317e4f9/as/pmi_G0000714_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:76adf145-b456-4d37-8978-e5ab7c5dc0ad/as/pmi_G0000714_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:689643bd-1572-4aac-9b4d-13ab0d04ca5b/as/pmi_G0000714_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:9f320283-c2ba-4ebb-9f7a-4dc9940f6cbe/as/pmi_G0000714_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002823.04',
          gtin: '4023500045308',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0000715',
          globalArticleName: 'TEREA Yellow',
          productLongDescription: 'TEREA Yellow repräsentieren eine feine und zugleich würzige Tabaksorte.',
          productShortDescription: '<p>Fein und weich</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          intensity: '3',
          body: '2',
          aroma: '5',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '#FFFF00',
                  code: 'YELLOW',
                  name: 'Gelb'
              },
              hexCode: '#FFCD00',
              code: 'YEL',
              description: 'YELLOW SELECTION',
              name: 'Fine and soft.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-packung-yellow',
              productsSeoTitle: 'TEREA Yellow kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Yellow Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME002825.11',
          gtin: '4023500045247',
          brand: 'TEREA'
      },
      {
          variantType: 'FLAVOR',
          globalArticleCode: 'G0001409',
          globalArticleName: 'TEREA Warm Fuse',
          productLongDescription: '<p>TEREA Warm Fuse&nbsp;überraschen mit einer facettenreichen und würzigen Tabakmischung.</p>',
          productShortDescription: '<p>Ausbalanciert und würzig.</p>',
          unitOfMeasure: 'PK',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 20,
          categoryIdentifier: 'P1',
          packSize: '1 pack(20)',
          nuance: {
              group: {
                  hexCode: '',
                  code: '',
                  name: ''
              },
              hexCode: '#89672F',
              code: 'WF1',
              description: 'Warm Fuse',
              name: 'Ausbalanciert und würzig.'
          },
          price: {
              value: 7,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-warm-fuse',
              productsSeoTitle: 'TEREA Warm Fuse kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Jetzt bestellen: TEREA Warm Fuse Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 10000,
              stockLevelStatus: 'inStock'
          },
          pmiInternalProductCode: 'ME006094.10',
          gtin: '4023500045315',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000717',
          globalArticleName: 'TEREA AMBER Stange',
          productLongDescription: 'TEREA Amber stehen für einen ausgewogenen sowie vollmundigen Tabak.',
          productShortDescription: 'Ausgewogen und vollmundig. Entspricht HEETS Amber.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '3',
          body: '3',
          aroma: '4',
          cooling: '4',
          nicotineConcentration: '15.55',
          intensityMeter: '4',
          tankSize: '8.25ml',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#FFA500',
                  code: 'LIGHTORANGE',
                  name: 'LIGHTORANGE'
              },
              hexCode: '#D86018',
              code: 'AMB',
              description: 'AMBER SELECTION',
              name: 'Ausgewogen und vollmundig. Entspricht HEETS Amber.'
          },
          price: {
              value: 70,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-amber',
              productsSeoTitle: 'TEREA Amber Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Amber Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:646b0fbb-18e2-40f3-aa43-6d9765719ee5/as/pmi_G0000717_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:ec79da33-818e-447b-ad28-d50832692096/as/pmi_G0000717_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:c0e2b1e2-9339-4f5f-ace7-dc79fb8ec839/as/pmi_G0000717_02_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002822.14',
          gtin: '4023500745239',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000722',
          globalArticleName: 'TEREA BRONZE Stange',
          productLongDescription: 'TEREA Bronze versprechen einen kräftigen und abgerundeten Tabak.',
          productShortDescription: 'Kräftig und abgerundet. Entspricht HEETS Bronze.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '3',
          aroma: '5',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#AA7956',
                  code: 'BROWN',
                  name: 'Braun'
              },
              hexCode: '#7C3A2D',
              code: 'BRS',
              description: 'BRONZE SELECTION',
              name: 'Kräftig und abgerundet. Entspricht HEETS Bronze.'
          },
          price: {
              value: 70,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-bronze',
              productsSeoTitle: 'TEREA Bronze Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Bronze Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:b0f9d19e-f9cd-4d1e-aeb2-b65c4bf823d5/as/pmi_G0000722_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:19fb6383-bbab-42ae-9782-d3d53f591783/as/pmi_G0000722_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:504d5214-4ebc-49d3-bfdf-5ae3c8202a92/as/pmi_G0000722_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:0b34014d-1a06-446a-8903-750fc7ebc14f/as/pmi_G0000722_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002824.01',
          gtin: '4023500739627',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000729',
          globalArticleName: 'TEREA RUSSET Stange',
          productLongDescription: 'TEREA Russet bestechen mit einem intensiven, gleichzeitig gerösteten Tabak.',
          productShortDescription: 'Intensiv und geröstet. Entspricht HEETS Russet.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '5',
          body: '3',
          aroma: '5',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#FF0000',
                  code: 'RED',
                  name: 'Rot'
              },
              hexCode: '#6F263D',
              code: 'RUS',
              description: 'Russet',
              name: 'Intensiv und geröstet. Entspricht HEETS Russet.'
          },
          price: {
              value: 80,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-russet',
              productsSeoTitle: 'TEREA Russet Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Russet Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:5a142398-9023-47c5-baac-2e2999ceb900/as/pmi_G0000729_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:71763e89-5d0e-4e24-8e06-155c6faf6e68/as/pmi_G0000729_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:5fc43b22-4e34-46cd-8cde-d189e545fdc1/as/pmi_G0000729_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:2b6f6dfa-2f5a-4a4b-bb77-497e9901d2d6/as/pmi_G0000729_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002826.11',
          gtin: '4023500745284',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000730',
          globalArticleName: 'TEREA SIENNA Stange',
          productLongDescription: 'TEREA Sienna kennzeichnen eine reichhaltige sowie holzige Tabaksorte.',
          productShortDescription: 'Reichhaltig und holzig. Entspricht HEETS Sienna.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '4',
          aroma: '3',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#FF0000',
                  code: 'RED',
                  name: 'Rot'
              },
              hexCode: '#B33D26',
              code: 'SIE',
              description: 'Sienna',
              name: 'Reichhaltig und holzig. Entspricht HEETS Sienna.'
          },
          price: {
              value: 60,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-sienna',
              productsSeoTitle: 'TEREA Sienna Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Sienna Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:fc418bb3-7ebb-4ef5-a804-d1355dd02c8d/as/pmi_G0000730_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:7392e590-277c-448b-b0dc-5d2089f7622a/as/pmi_G0000730_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:b779f780-f593-4a76-871d-ccc05234ba98/as/pmi_G0000730_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:86664d7c-25cb-42a1-91c6-59ac2d844427/as/pmi_G0000730_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME006515.08',
          gtin: '4023500745277',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000735',
          globalArticleName: 'TEREA TEAK Stange',
          productLongDescription: 'TEREA Teak verkörpern eine gereifte und sinnlich warme Tabakmischung.',
          productShortDescription: 'Gereift und warm. Entspricht HEETS Teak.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '3',
          aroma: '4',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#AA7956',
                  code: 'BROWN',
                  name: 'Braun'
              },
              hexCode: '#AE8A79',
              code: 'TEA',
              description: 'Teak',
              name: 'Gereift und warm. Entspricht HEETS Teak.'
          },
          price: {
              value: 70,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-teak',
              productsSeoTitle: 'TEREA Teak Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Teak Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:2d9e8ad3-239d-40da-bef8-8fe84ca0893e/as/pmi_G0000735_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:003486b4-7580-4e49-8d49-9287062ed0f2/as/pmi_G0000735_03_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:34a5545e-f84a-4f66-8129-3e99eda9c575/as/pmi_G0000735_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:67068420-c87d-4c6f-b166-8a8d21257837/as/pmi_G0000735_01_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002821.11',
          gtin: '4023500745291',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000738',
          globalArticleName: 'TEREA TURQUOISE Stange',
          productLongDescription: 'TEREA Turquoise zeichnen sich durch unmittelbare Menthol-Frische aus. Eine dezente und feine Tabakmischung.',
          productShortDescription: 'Mentholig und dezent. Entspricht HEETS Turquoise.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '2',
          body: '2',
          aroma: '1',
          cooling: '2',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#00B050',
                  code: 'GREEN',
                  name: 'Grün'
              },
              hexCode: '#008C95',
              code: 'TUR',
              description: 'TURQUOISE SELECTION',
              name: 'Mentholig und dezent. Entspricht HEETS Turquoise.'
          },
          price: {
              value: 90,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-turquoise-testTereaUrl',
              productsSeoTitle: 'TEREA Turquoise Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Turquoise Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1100,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:bb226c7c-c9f2-425b-961e-c6f7ece5ec5e/as/pmi_G0000738_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:802703b8-450a-41f2-b67b-363ad71331b1/as/pmi_G0000738_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:c580d837-a54c-4c96-bed3-b5ddf6c0de06/as/pmi_G0000738_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:77e0e3e1-b60b-47ef-8bc5-40057c82a34d/as/pmi_G0000738_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME005197.01',
          gtin: '4023500738392',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000740',
          globalArticleName: 'TEREA YELLOW GREEN Stange',
          productLongDescription: 'TEREA Yellow Green eröffnen eine zitrisch, reichhaltige Komposition mit Kräuternote. Ein überaus kraftvoller Tabak.',
          productShortDescription: 'Ausgeprägt und würzig. Entspricht HEETS Yellow Green.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '4',
          body: '2',
          aroma: '5',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#00B050',
                  code: 'GREEN',
                  name: 'Grün'
              },
              hexCode: '#999B30',
              code: 'YEG',
              description: 'YELLOW GREEN',
              name: 'Ausgeprägt und würzig. Entspricht HEETS Yellow Green.'
          },
          price: {
              value: 70,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-yellow-green',
              productsSeoTitle: 'TEREA Yellow Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Yellow Green Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:2ae804e5-0ba6-421c-a9d6-73c8330c8a91/as/pmi_G0000740_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:301487cc-85ed-4c2d-8e8f-ef4f11bf1320/as/pmi_G0000740_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:ca9822c9-1263-48b9-a9b7-eea24d9b1aa5/as/pmi_G0000740_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:005c315e-99ce-4d4f-9b4f-0eeef6a65db8/as/pmi_G0000740_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002823.10',
          gtin: '4023500745307',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0000739',
          globalArticleName: 'TEREA YELLOW Stange',
          productLongDescription: 'TEREA Yellow repräsentieren eine feine und zugleich würzige Tabaksorte.',
          productShortDescription: 'Fein und weich. Entspricht HEETS Yellow.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          categoryIdentifier: 'P1',
          intensity: '3',
          body: '2',
          aroma: '5',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#FFFF00',
                  code: 'YELLOW',
                  name: 'Gelb'
              },
              hexCode: '#FFCD00',
              code: 'YEL',
              description: 'YELLOW SELECTION',
              name: 'Fein und weich. Entspricht HEETS Yellow.'
          },
          price: {
              value: 70,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-yellow',
              productsSeoTitle: 'TEREA Yellow Green Stange kaufen',
              productsSeoDescription: 'Jetzt bestellen: TEREA Yellow Stange - 10 Packungen - Sie enthalten eine fein abgestimmte Tabakmischung. Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:24a6c16d-21c2-49be-bf0f-58c2b351daef/as/pmi_G0000739_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:bbc9e029-200d-4abf-ae75-6a7dd58d71a5/as/pmi_G0000739_03_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:133c645d-ffd5-47e7-b98f-9d3ea8d52978/as/pmi_G0000739_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:f129510a-59ac-41a8-b468-053ce020a7b4/as/pmi_G0000739_01_de.png'
              }
          ],
          pmiInternalProductCode: 'ME002825.11',
          gtin: '4023500745246',
          brand: 'TEREA'
      },
      {
          variantType: 'SIZE',
          globalArticleCode: 'G0001413',
          globalArticleName: 'TEREA Warm Fuse Stange',
          productLongDescription: 'Ausbalanciert und würzig.\n\n\n\nTEREA Warm Fuse überraschen mit einer facettenreichen und würzigen Tabakmischung.',
          productShortDescription: 'Ausbalanciert und würzig.',
          unitOfMeasure: 'CT',
          maximumOrderQuantity: 10,
          minimumOrderQuantity: 1,
          nominalContentPerUnitOfSales: 200,
          loyaltyLevel: [
              'Platinum'
          ],
          categoryIdentifier: 'P1',
          packSize: '1 stick(200)',
          nuance: {
              group: {
                  hexCode: '#00B050',
                  code: 'BLUE',
                  name: 'Blau'
              },
              hexCode: '#89672F',
              code: 'WF1',
              description: 'Warm Fuse',
              name: 'Ausbalanciert und würzig.'
          },
          price: {
              value: 8,
              priceCurrency: 'EUR',
              priceChannel: 'web',
              priceType: 'Gross Price',
              isServiceFeeIncluded: false
          },
          seo: {
              productsSeoUrl: 'terea-stange-10-warm-fuse',
              productsSeoTitle: 'TEREA Warm Fuse kaufen | Für IQOS ILUMA',
              productsSeoDescription: 'Exklusiv auf IQOS.com: Die neuen TEREA Warm Fuse Tabaksticks - Stange oder Einzelpackung | Nur für die Verwendung mit IQOS ILUMA.'
          },
          stock: {
              stockLevel: 1000,
              stockLevelStatus: 'inStock'
          },
          assets: [
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:3288ca11-262e-46c0-819e-462904357133/as/pmi_G0001413_00_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:a1a9b0ee-8cf3-4f81-9ef5-cf1d4d0da0f4/as/pmi_G0001413_01_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:77fce357-d369-4f97-9994-b45350818bba/as/pmi_G0001413_02_de.png'
              },
              {
                  view: 'Front View',
                  assetType: 'Image',
                  channelExclusivity: 'B2C',
                  assetFullUrl: 'https://delivery-p24719-e80955.adobeaemcloud.com/adobe/assets/urn:aaid:aem:b9243d7c-bae7-4fe3-863f-f9af2cae9c12/as/pmi_G0001413_03_de.png'
              }
          ],
          pmiInternalProductCode: 'ME006094.01',
          gtin: '4023500742306',
          brand: 'TEREA'
      }
  ],
  stock: {
      stockLevel: 10000,
      stockLevelStatus: 'inStock'
  },
  nuance: {
      group: {
          hexCode: '#FF0000',
          code: 'RED',
          name: 'Rot'
      },
      hexCode: '#6F263D',
      code: 'RUS',
      description: 'Russet',
      name: 'Intense and roasted.'
  },
  brand: 'TEREA',
  aroma: '2',
  body: '3',
  intensity: '5',
  packSize: '1 pack(20)',
  pmiInternalProductCode: 'ME002826.11',
  gtin: '4023500045285'
}

export default MockData
